import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { usePreferredUnitSystem } from 'utils/measurement/hooks';

import { getDimensionalPrecision, getDisplayScale } from '../data/reducer';

const VolumeAreaWeightDisplayContainer = styled.div`
  color: inherit;
  display: flex;
  flex-direction: column;
  font-size: 13px;
  line-height: 1.5;
  text-align: right;
  width: 200px;
`;

const Title = styled.span`
  font-weight: 700;
`;

const Entry = styled.span``;

type VolumeAreaWeightDisplayProps = {
  isEnabled: boolean;
  properties: {
    area: number;
    volume: number;
    weight: number;
  };
};

const VolumeAreaWeightDisplay = ({
  isEnabled,
  properties,
}: VolumeAreaWeightDisplayProps) => {
  const displayScale = useSelector(getDisplayScale);
  const dimensionalPrecision = useSelector(getDimensionalPrecision);
  const { area, volume, weight } = properties;

  const { formatVolume, formatArea, formatWeight } = usePreferredUnitSystem();

  const volString =
    volume > 0
      ? formatVolume(volume, { decimalPoints: dimensionalPrecision })
      : '';

  const areaString =
    area > 0 ? formatArea(area, { decimalPoints: dimensionalPrecision }) : '';

  const weightString = weight
    ? formatWeight({
        weight,
        dimensionalPrecision,
        displayScale,
      })
    : '';

  if (!isEnabled) return null;
  if (!volString && !areaString && !weightString) return null;

  return (
    <VolumeAreaWeightDisplayContainer>
      <Title>File</Title>
      {volString && <Entry>{`Volume: ${volString}`}</Entry>}
      {areaString && <Entry>{`Area: ${areaString}`}</Entry>}
      {weightString && <Entry>{`Weight: ${weightString}`}</Entry>}
    </VolumeAreaWeightDisplayContainer>
  );
};

export default VolumeAreaWeightDisplay;
